enum ActionTypes {
  SET_STATES = 'SET_STATES',
  LOAD_STATES_REQUEST = 'LOAD_STATES_REQUEST',
  LOAD_STATES_SUCCESS = 'LOAD_STATES_SUCCESS',
  LOAD_STATES_FAILURE = 'LOAD_STATES_FAILURE'
}

export default ActionTypes;
